// 公告班表
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import '../../../scss/components/pages/edit_staff_shift.scss';
import { GetStoreRole } from'../../../const/constant';
import EditShiftBlockInAdjust from '../../EditShiftBlockInAdjust';
import Calendar from '../../Calendar';


import {
  getSupportScheduleShiftDate,
  InitAPIStatus,
  editWorkTime,
  deleteStaffInAdjust
} from '../../../store/action';

class SupportShiftDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarConfig: {
        defaultView: "timelineDay",
        draggable: false,
        isEventClick: false,
        isDayClick: false,
        header: {
          left: 'title',
          center: '',
          right: '',
        },
      },
      resources: [],
      events: [],
      isEditBlockOpen: false,
      editEvent: {},
      role: GetStoreRole(localStorage.getItem('current_store_id')),
    }
    this.handleToggleEditShiftOpen = this.handleToggleEditShiftOpen.bind(this);
    this.handleEditshiftByEvent = this.handleEditshiftByEvent.bind(this);
    this.handleSaveEditWorkTime = this.handleSaveEditWorkTime.bind(this);
    this.handleDeleteStaffInAdjust = this.handleDeleteStaffInAdjust.bind(this);
  }

  componentDidMount() {
    let { day } = this.props.match.params;
    this.props.getSupportScheduleShiftDate(day);
  }

  handleToggleEditShiftOpen() {
    this.setState({
      isEditBlockOpen: !this.state.isEditBlockOpen
    });
  }

  handleEditshiftByEvent(event) {
    if (this.state.role === '4') return;
    this.setState({
      editEvent: event,
      isEditBlockOpen: true
    });
  }

  handleSaveEditWorkTime(targetevent) {
    let { day } = this.props.match.params;
    this.props.editWorkTime(targetevent, () => {this.props.getSupportScheduleShiftDate(day)});
  }

  handleDeleteStaffInAdjust(eventObj) {
    let { day } = this.props.match.params;
    this.props.deleteStaffInAdjust(eventObj.id, () => {this.props.getSupportScheduleShiftDate(day)});
  }

  componentWillReceiveProps(nextProsp) {
    const { resources, events } = nextProsp.adjustmentScheduleDetailState;
    var eventIndex = [];
    var resourceId = [];

    var formalResource = [];
    var unformalResource = [];



    let newResources = resources.map((item, index) => {
            item.textColor = 'black';

      if (item.jobTypeId === 2) {
        item.eventColor = '#FFD966';
      } else if (item.jobTypeId === 3) {
        item.eventColor = '#EA9999';
      } else if (item.jobTypeId === 7 || item.jobTypeId === 4 || item.jobTypeId === 5 || item.jobTypeId === 6 || item.jobTypeId === 21) {
        item.eventColor = '#F4CCCC';
      } else if (item.jobTypeId === 12 || item.jobTypeId === 13 || item.jobTypeId === 14 || item.jobTypeId === 16) {
        item.eventColor = '#D9EAD3';
      } else if (item.jobTypeId === 8) {
        item.eventColor = '#6FA8DC';
      } else if (item.jobTypeId === 9 || item.jobTypeId === 10) {
        item.eventColor = '#CFE2F3';
      } else if (item.jobTypeId === 11) {
        item.eventColor = '#B6D7A8';
      } else if (item.jobTypeId === 15 || item.jobTypeId === 17 || item.jobTypeId === 18 || item.jobTypeId === 19) {
        item.eventColor = '#FFF2CC';
      }
      if (item.title.indexOf('-') === -1) {
        eventIndex.push(index);
        resourceId.push(item.id);
        item.title = '本日活動';
        item.id = -1;
        item.eventColor = 'Plum';
      }
      if (item.title.indexOf('兼職') !== -1) {
        unformalResource.push(item);
      }else{
        formalResource.push(item);
      }
      return item;
    });

        if (eventIndex.length > 0) {
      for (var i = eventIndex.length - 1; i >= 0; i--) {        
        var b = newResources[eventIndex[i]];
        newResources[eventIndex[i]] = newResources[i];
        newResources[i] = b;
      }
    }
    let orderedResource = formalResource.concat(unformalResource);
    eventIndex = [];
    for (var j = orderedResource.length - 1; j >= 0; j--) {        
      if (orderedResource[j].title.indexOf('-') === -1) {
        eventIndex.push(j)
      }
    } 
    if (eventIndex.length > 0) {
      for (var k = eventIndex.length - 1; k >= 0; k--) {        
        var bb = orderedResource[eventIndex[k]];
        orderedResource[eventIndex[k]] = orderedResource[k];
        orderedResource[k] = bb;
      }
    }
    
    // let newEvents = events.map((item, index) => {
    //   if (resourceId.indexOf(item.resourceId) != -1 && item.title.indexOf('-') === -1) {
    //     item.resourceId = -1;
    //   }
    //   return item;

    // });
    this.setState({
      resources: newResources,
      events: events
    });
  }

  render() {
    let { day } = this.props.match.params;
    let events = [...this.state.events];
    let resources = [...this.state.resources];

    return (
      <div className="p-editShift">
        <div className="u-block overflow-x">
          <div className="u-title">支援班表</div>
          <div className="p-editShift__calendar">
            <Calendar {...this.state.calendarConfig}
              events={events}
              resources={resources}
              defaultDate={day}

              deleteResourceFunc={this.handleEditshiftByEvent}
            />
          </div>
        </div>
        <EditShiftBlockInAdjust isVisible={this.state.isEditBlockOpen} 
          toggleOpen={this.handleToggleEditShiftOpen}
          event={this.state.editEvent}
          saveWorkTime={this.handleSaveEditWorkTime}
          deleteWorkTime={this.handleDeleteStaffInAdjust}
          jobType="2"
        />
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  SendAPIState: store.SendAPIStatusState,
  adjustmentScheduleDetailState: store.adjustmentScheduleDetailState,
})

export default connect(mapStateToProps,{
  getSupportScheduleShiftDate,
  InitAPIStatus,
  editWorkTime,
  deleteStaffInAdjust
})(withRouter(SupportShiftDetail));